import React, { useEffect, useState } from "react";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import "./GenericFilterItem.css";
import SouthIcon from "@mui/icons-material/South";
import { Filter, FilterItem } from "../../context/ConfigContext/types";
import { useConfig } from "../../context/ConfigContext";

export interface GenericFilterItemProps {
  filter: Filter;
  size?: "small" | "medium";
}

const GenericFilterItem: React.FunctionComponent<GenericFilterItemProps> = ({ filter, size = "medium" }) => {
  const { toggleFilterChecked } = useConfig();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<FilterItem[]>([]);

  useEffect(() => {
    const checkedItems = filter?.filterItems?.filter((item) => item.checked);
    setSelectedItems(checkedItems);
  }, [filter]);

  const handleChange = (newItems: FilterItem[]) => {
    const changedItem = newItems.length
      ? newItems.find((val) => !selectedItems.includes(val)) || selectedItems.find((val) => !newItems.includes(val))
      : null;

    if (changedItem) return toggleFilterChecked(filter.filterName, changedItem.value as string);
    toggleFilterChecked(filter.filterName, null, true);
  };

  return (
    <div className="genericFilter">
      <Autocomplete
        sx={{ m: 1, width: "100%" }}
        limitTags={0}
        size={size}
        multiple
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={selectedItems}
        options={filter.filterItems}
        popupIcon={<SouthIcon />}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        onChange={(event: any, newValues: any[]) => {
          handleChange(newValues);
        }}
        renderOption={(props, option) => (
          <Box key={option.value} component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
            {getHumanReadableValue(option.value)}
          </Box>
        )}
        getOptionLabel={(option: any) => (option ? option.value : "")}
        disableCloseOnSelect
        renderTags={(options) => {
          if (!isOpen) {
            return (
              <Typography sx={{ paddingLeft: "6px" }}>{getTagValue(filter.filterName, options.length)}</Typography>
            );
          }
          return "";
        }}
        renderInput={(params) => {
          return (
            <div
              style={{
                width: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <TextField
                size="small"
                variant="outlined"
                placeholder={
                  isOpen
                    ? "search"
                    : selectedItems.length < 1
                    ? `any ${filter.filterName.toLowerCase()}`
                    : filter.filterName.length > 10
                    ? ""
                    : "search"
                }
                {...params}
              />
            </div>
          );
        }}
      />
    </div>
  );
};

export default GenericFilterItem;

export const getHumanReadableValue = (originalValue) => {
  return originalValue.replace(/_/g, " ").toLowerCase();
};

const getTagValue = (filterName, optionsLength) => {
  if (optionsLength === 0) return `any ${filterName}`;
  if (optionsLength === 1) return `${optionsLength} ${filterName.toLowerCase()}`;
  return filterName.endsWith("y")
    ? `${optionsLength} ${filterName.slice(0, -1)}ies`
    : `${optionsLength} ${filterName.toLowerCase()}s`;
};
